var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-analytics" },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c(
          "div",
          { staticClass: "info-banner" },
          [
            _c("a-alert", {
              attrs: {
                message: "Template Analytics Hakkında",
                description:
                  "Template analytics için template seçmeniz gerekmektedir. Maksimum 10 template seçebilirsiniz. Analytics verileri günlük granularity ile döner ve 90 günlük geçmiş verisine erişebilirsiniz.",
                type: "info",
                "show-icon": "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "template-selector" },
          [
            _c("label", [_vm._v("Template Seçin (Maksimum 10)")]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  mode: "multiple",
                  value: _vm.selectedTemplateIds,
                  placeholder: "Template seçin...",
                  "max-tag-count": 5,
                },
                on: { change: _vm.onTemplateSelect },
              },
              _vm._l(_vm.templates, function (template) {
                return _c(
                  "a-select-option",
                  { key: template.id, attrs: { value: template.id } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(template.name) +
                        " (" +
                        _vm._s(template.language) +
                        ")\n                "
                    ),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "fetch-btn",
                attrs: {
                  type: "primary",
                  disabled: _vm.selectedTemplateIds.length === 0,
                },
                on: { click: _vm.fetchData },
              },
              [_vm._v("\n                Verileri Getir\n            ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.loading && _vm.data && _vm.data.data && _vm.data.data.length > 0
          ? _c("div", [
              _c("div", { staticClass: "toolbar" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Grafik Görünümü" },
                            expression: "{ content: 'Grafik Görünümü' }",
                          },
                        ],
                        attrs: {
                          classNames: !_vm.tableMode ? "selected" : "",
                          onClick: function () {
                            return (_vm.tableMode = false)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("insights")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Tablo Görünümü" },
                            expression: "{ content: 'Tablo Görünümü' }",
                          },
                        ],
                        attrs: {
                          classNames: _vm.tableMode ? "selected" : "",
                          onClick: function () {
                            return (_vm.tableMode = true)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("table_view")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: { content: "Excel İndir" },
                            expression: "{ content: 'Excel İndir' }",
                          },
                        ],
                        attrs: { onClick: _vm.exportToExcel },
                      },
                      [_c("md-icon", [_vm._v("download")])],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stats-row" },
                [
                  _c("StatCard", {
                    attrs: {
                      title: "Toplam Gönderilen",
                      value: _vm.totalSent,
                      unit: "mesaj",
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: "Toplam Teslim Edilen",
                      value: _vm.totalDelivered,
                      unit: "mesaj",
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: "Toplam Okunma",
                      value: _vm.totalRead,
                      unit: "mesaj",
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: "Okunma Oranı",
                      value: _vm.readRate,
                      unit: "%",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.tableMode
                ? _c(
                    "div",
                    { staticClass: "chart-container" },
                    [
                      _c("StackedAreaChart", {
                        attrs: {
                          title: "Template Performansı",
                          "x-axis-data": _vm.getXAxisData(),
                          legends: ["Gönderilen", "Teslim Edilen", "Okunmuş"],
                          colors: ["#37A2FF", "#80FFA5", "#FFBF00"],
                          series: _vm.getSeries(),
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "table-container" },
                    [
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.tableData,
                          pagination: { pageSize: 10 },
                          size: "middle",
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.hasCostData
                ? _c("div", { staticClass: "cost-section" }, [
                    _c("h3", [_vm._v("Maliyet Bilgileri")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cost-cards" }, [
                      _c("div", { staticClass: "cost-card" }, [
                        _c("div", { staticClass: "cost-label" }, [
                          _vm._v("Toplam Harcama"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cost-value" }, [
                          _vm._v("$" + _vm._s(_vm.totalAmountSpent.toFixed(2))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cost-card" }, [
                        _c("div", { staticClass: "cost-label" }, [
                          _vm._v("Teslim Başına Maliyet"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cost-value" }, [
                          _vm._v(
                            "$" + _vm._s(_vm.avgCostPerDelivered.toFixed(4))
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasClickData
                ? _c("div", { staticClass: "click-section" }, [
                    _c("h3", [_vm._v("Tıklama Bilgileri")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "click-info" }, [
                      _c("p", [
                        _vm._v(
                          "\n                        URL ve Quick Reply buton tıklamaları sadece MARKETING ve UTILITY kategorisindeki\n                        template'ler için mevcuttur.\n                    "
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ])
          : !_vm.loading
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("a-empty", {
                  attrs: {
                    description:
                      "Template analytics verisi bulunamadı. Template ID'lerini belirleyerek veri çekebilirsiniz.",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }